import { configureStore } from '@reduxjs/toolkit'
import structure from './features/structure'
import tables from './features/tables'
import browse from './features/browse'
import settings from './features/settings'
import documents from './features/documents'
import { documentsSettingsApi } from './api/documents-settings.api'
import { systemTablesApi } from './api/system-tables.api'
import { customTablesApi } from './api/custom-tables.api'
import { accountsStructureApi } from './api/accounts-structure.api'
import { accountsApi } from './api/accounts.api'
import { documentsStructureApi } from './api/documents-structure.api'
import { documentsApi } from './api/documents.api'

export const store = configureStore({
  reducer: {
    structure: structure,
    tables : tables,
    browse : browse,
    settings: settings,
    documents: documents,
    [documentsApi.reducerPath]: documentsApi.reducer,
    [documentsSettingsApi.reducerPath]: documentsSettingsApi.reducer,
    [documentsStructureApi.reducerPath]: documentsStructureApi.reducer,
    [systemTablesApi.reducerPath]: systemTablesApi.reducer,
    [customTablesApi.reducerPath]: customTablesApi.reducer,
    [accountsStructureApi.reducerPath]: accountsStructureApi.reducer,
    [accountsApi.reducerPath]: accountsApi.reducer,

  },
  middleware: (getDefault) =>
    getDefault().concat(
      documentsApi.middleware,
      documentsSettingsApi.middleware,
      documentsStructureApi.middleware,
      systemTablesApi.middleware,
      customTablesApi.middleware,
      accountsStructureApi.middleware,
      accountsApi.middleware,
    ),
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;